import React, { useState, useEffect } from "react";
import { getOrganisation } from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import { CiEdit } from "react-icons/ci";
import { MdRemoveRedEye } from "react-icons/md";
import Modal from './Model'
import UpdateModal from "./UpdateModel";

const OrgTable = () => {
  const [organisations, setOrganisations] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [updateModalData, setUpdateModalData] = useState(null);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);

  const token = useSelector((store) => store.userReducer.token);

  const viewData = (item, setModalData, setOpenModal) => {
    setModalData(item);
    setOpenModal(true);
  };

  const updateFunction = (item, setUpdateModalData, setIsUpdateModalOpen) => {
    setUpdateModalData(item);
    setIsUpdateModalOpen(true);
  };

  useEffect(() => {
    const fetchOrganisations = async () => {
      try {
        const response = await getOrganisation(token);
        if (response.success) {
          setOrganisations(response.data);
        } else {
          console.error("Failed to fetch organisations:", response.message);
        }
      } catch (error) {
        console.error("Error fetching organisations:", error);
      }
    };

    fetchOrganisations();
  }, [token]);

  return (
    <>
      <h1 style={{ marginBottom: "20px" }}>List of Organizations</h1>
      <div className="table-main-div">
        <table className="table-user-management">
          <thead className="table-user-header">
          <tr>
              <td>
                <p className="user-table-head">S.No</p>
              </td>
              <td>
                <p className="user-table-head"> Org Name</p>
              </td>
              <td>
                <p className="user-table-head">Org Domain URL</p>
              </td>
              <td>
                <p className="user-table-head">Status</p>
              </td>
              <td>
                <p className="user-table-head">Update</p>
              </td>
              <td>
                <p className="user-table-head">View</p>
              </td>
            </tr>
          </thead>
          <tbody>
          {organisations.map((org, i) => (
              <tr key={org.id} className="table-user-data">
                <td>
                  <p className="user-table-head">{i + 1}</p>
                </td>
                <td>
                  <p className="user-table-head">{org.orgName}</p>
                </td>
                <td>
                  <p className="user-table-head">{org.orgDomainURL}</p>
                </td>
                <td>
                  <div className="status-table">
                    {org.isActive ? (
                      <p className="user-table-head">
                        <span className="green-dot"></span>
                      </p>
                    ) : (
                      <span className="red-dot"></span>
                    )}
                    <p className={org.isActive ? "active" : "inactive"}>
                      {org.isActive ? "Active" : "Inactive"}
                    </p>
                  </div>
                </td>
                <td>
                  <p className="user-table-head">
                  <CiEdit
                    style={{ width: "1.2rem", height: "1.2rem", cursor: "pointer" }}
                    onClick={() => updateFunction(org, setUpdateModalData, setIsUpdateModalOpen)}
                  />
                  </p>
                </td>
                <td>
                  <p
                    className="user-table-head"
                    onClick={() =>
                      viewData(org, setModalData, setOpenModal)
                    }
                  >
                    <MdRemoveRedEye
                      style={{
                        width: "1.2rem",
                        height: "1.2rem",
                        cursor: "pointer",
                      }}
                    />
                  </p>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {openModal && modalData && <Modal modalData={modalData} setOpenModal={setOpenModal} />}

      {isUpdateModalOpen && updateModalData && (
        <UpdateModal
          updateModalData={updateModalData}
          setIsUpdateModalOpen={setIsUpdateModalOpen}
          token={token}
        />
      )}    
    </>
  );
};

export default OrgTable;
